import React, { useEffect, useState } from 'react';
import { Play, Info } from 'lucide-react';
import { fetchFrom, endpoints as defaultEndpoints, IMG_BASE } from '../utils/tmdb';

const truncate = (str, n) => (str?.length > n ? str.substr(0, n - 1) + '...' : str);

const Hero = ({ onMoreInfo, fetchPath }) => {
  const [movie, setMovie] = useState(null);

  useEffect(() => {
    (async () => {
      const list = await fetchFrom(fetchPath || defaultEndpoints.netflixOriginals);
      if (list.length) {
        const filtered = list.filter((m) => m.backdrop_path);
        if (filtered.length)
          setMovie(filtered[Math.floor(Math.random() * filtered.length)]);
      }
    })();
  }, [fetchPath]);

  if (!movie) {
    return <div className="h-[85vh] bg-[#141414]" />;
  }

  return (
    <header
      className="relative h-[92vh] w-full text-white"
      style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        backgroundImage: `url(${IMG_BASE}${movie.backdrop_path})`,
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#141414] to-transparent" />

      <div className="relative z-10 flex flex-col justify-end h-full pb-32 px-4 md:px-14 max-w-3xl">
        <h1 className="text-4xl md:text-6xl font-extrabold drop-shadow-lg">
          {movie.title || movie.name || movie.original_name}
        </h1>
        <p className="mt-4 text-sm md:text-lg max-w-xl text-white/90 drop-shadow-md">
          {truncate(movie.overview, 200)}
        </p>
        <div className="mt-6 flex gap-3">
          <button
            onClick={() => onMoreInfo(movie)}
            className="flex items-center gap-2 bg-white text-black font-semibold px-6 py-2.5 rounded hover:bg-white/80 transition-colors"
          >
            <Play className="w-5 h-5 fill-black" /> Play
          </button>
          <button
            onClick={() => onMoreInfo(movie)}
            className="flex items-center gap-2 bg-[#6d6d6eB3] text-white font-semibold px-6 py-2.5 rounded hover:bg-[#6d6d6e80] transition-colors"
          >
            <Info className="w-5 h-5" /> More Info
          </button>
        </div>
      </div>
    </header>
  );
};

export default Hero;
